/* eslint-disable */
import { API_BASE } from '@shared/constants/config';
import { GET, REST_API } from '@shared/constants/rest-api';

export const GET_INFO_COMPANY_START = 'GET_INFO_COMPANY_START';
export const GET_INFO_COMPANY_SUCCESS = 'GET_INFO_COMPANY_SUCCESS';
export const GET_INFO_COMPANY_FAIL = 'GET_INFO_COMPANY_FAIL';

const headers = {
  Accept: '*/*',
  'Content-Type': 'application/json',
};

export const getInfoCompany = (onSuccess, onError) => ({
  type: REST_API,
  method: GET,
  url: `${API_BASE}/api/v1/company/domain`,
  headers: { ...headers },
  types: [GET_INFO_COMPANY_START, GET_INFO_COMPANY_SUCCESS, GET_INFO_COMPANY_FAIL],
  onSuccess,
  onError,
});
